import { PermissionsEnum } from "@/auth/interfaces";
import { EstadosPreagendamientoEnumChoice, ModulosEnumChoice, TABLE_CONSTANTS } from "@/shared";
import { GeneralTable } from "@/shared/components/ui";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ModalMotivoRechazo from "@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo";
import { useModalMotivoRechazo } from "@/shared/components/ui/ModalMotivoRechazo/useModalMotivoRechazo";
import CustomSearchFilterSupervisorVenta from "@/erp/sale/asesor/prospecto/componente/CustomSearchProspecto/CustomSearchFilterSupervisorVenta";
import { useTablePreagendamientoPymes } from "../../hook/useTablePreagendamientoPymes";
import { useFetchPreagendamientosPymes } from "@/shared/actions/erp/operaciones/preagendamiento/preagendamiento_pymes.actions";
import { IPreagendamientoPymes } from "@/shared/interfaces/erp/ventas_pymes/preagendamiento_pymes.interface";
import useEstadoInstalacionSofnet from "@/shared/hooks/useEstadoInstalacionSofnet";

interface TablePreAgendamientoPymesProps {
  estado_preagendamiento: EstadosPreagendamientoEnumChoice
  enable_actions?: boolean
}

const TablePreAgendamientoPymes = ({
  estado_preagendamiento,
  enable_actions = true
}: TablePreAgendamientoPymesProps) => {

  useCheckPermissions(PermissionsEnum.api_view_preagendamientopymes);

  ///* Hook
  const {
    columnaPreagendamientoPymes
  } = useTablePreagendamientoPymes()

  const useHookModalMotivoRechazo = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.PREAGENDAMIENTO_PYMES
  })

  const {
    globalFilter,
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,
    vendedor,
    setVendedor

  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  ///* React Query

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const {
    handleValidacion
  } = useEstadoInstalacionSofnet()

  const {
    isLoading,
    data: agendaRes,
    isRefetching
  } = useFetchPreagendamientosPymes(
    {
      enabled: true,
      params: {
        estado_preagendamiento_in:
          estado_preagendamiento === EstadosPreagendamientoEnumChoice.EN_ESPERA ?
            `${EstadosPreagendamientoEnumChoice.EN_ESPERA},${EstadosPreagendamientoEnumChoice.EN_PAUSA}`
            : estado_preagendamiento
        ,
        identificacion: searchTerm,
        page: pageIndex + 1,
        page_size: pageSize,
        fecha_after: dateAfter,
        fecha_before: dateBefore,
        user_create: vendedor,
        es_pyme: true,
        ...filterObject,
        filterByState: false
      }
    }
  );


  return (
    <>
      <Grid container spacing={2} >

        <Grid item xs={12}>
          <CustomSearchFilterSupervisorVenta
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificación"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}
            setVendedor={setVendedor}
          />
        </Grid>


        <Grid item xs={12}>
          <GeneralTable<IPreagendamientoPymes>
            columns={columnaPreagendamientoPymes}
            data={agendaRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={agendaRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // crud
            canEdit={false}
            showCustomActionBtnSpace={enable_actions}
            enableColumnActions={enable_actions} /// 
            enableEditing={enable_actions}

            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
            customActionBtnSpace={(value) => {
              //console.log(value)
              return (
                <Grid container>

                  <Grid item>
                    <Tooltip title={'Cancelar'} placement="top">
                      <IconButton
                        color="error"
                        onClick={async () => {

                          const aux = await handleValidacion(value.id_instalacion_externa);

                          if (aux) return;

                          useHookModalMotivoRechazo.setDialogContentText(`Estás a punto de cancelar un Preagendamiento del cliente ${value.prospecto_pymes_data.razon_social} con identificación ${value.prospecto_pymes_data.identificacion}. ¿Estás seguro? Este cambio es irreversible.`)
                          useHookModalMotivoRechazo.setModalCancelar(true)
                          useHookModalMotivoRechazo.reset({
                            id: value.id_preagendamiento_pymes,
                            identificacion: value.prospecto_pymes_data.identificacion,
                            razon_social: value.prospecto_pymes_data.razon_social,
                            observaciones: value.observaciones
                          })
                        }
                        }
                      >
                        <HighlightOffIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>

                </Grid>
              )
            }}
          />
        </Grid>
      </Grid >


      {/*Modal para cancelar*/}

      <ModalMotivoRechazo
        {...useHookModalMotivoRechazo}
      />

    </>
  );

}

export default TablePreAgendamientoPymes;